import { TokenService } from "../services/token.service";
import { Injectable } from "@angular/core";
import { ToastrAlertService } from "../services/toastrAlert.service";
import { SweetAlertService } from "../services/sweet-alert.service";
import { TranslateService } from "@ngx-translate/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";

@Injectable({
  providedIn: "root",
})
export class PwdExpiratedGuard implements CanActivate {
  constructor(
    private tokenService: TokenService,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private translateService: TranslateService,
    private sweetAlertService: SweetAlertService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.tokenService.validateExpirationPassword()) {
      this.translateService.get("messages.passwordExpired").subscribe(
        (data) => {
          let message = data;
          this.sweetAlertService.sweetAlertBasic(message);
          this.router.navigate([RoutingConstants.changePassword.list]);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
      return false;
    }
    return true;
  }
}
